import { configureStore } from '@reduxjs/toolkit';
import { authSlice } from './slices/authSlice';
import { cartSlice } from './slices/cartSlice';
import { productsSlice } from './slices/productsSlice';
import { ordersSlice } from './slices/ordersSlice';
import { shopsSlice } from './slices/shopsSlice';
import { uiSlice } from './slices/uiSlice';
import filterOptionsReducer from './slices/filterOptionsSlice';
import productFiltersReducer from './slices/productFiltersSlice';
import categoriesReducer from './slices/categoriesSlice';
import platformSettingsReducer from './slices/platformSettingsSlice';

export const store = configureStore({
  reducer: {
    auth: authSlice.reducer,
    cart: cartSlice.reducer,
    products: productsSlice.reducer,
    orders: ordersSlice.reducer,
    shops: shopsSlice.reducer,
    ui: uiSlice.reducer,
    filterOptions: filterOptionsReducer,
    productFilters: productFiltersReducer,
    categories: categoriesReducer,
    platformSettings: platformSettingsReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
